import * as React from "react";
import Svg, { Path } from "react-native-svg";
function RemovePledge(props) {
    return (React.createElement(Svg, { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement(Path, { d: "M5 12h14", stroke: props.color || "#1434CB", strokeWidth: 2, strokeLinecap: "round" })));
}
export default RemovePledge;
